export default __webpack_public_path__ + "49bd0312ff6408659d541a24b2802545.svg";